import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { RefreshCw, Circle } from "lucide-react";

const LABELS = {
  mongo: "MongoDB",
  scheduler: "Reminder scheduler",
  stripe: "Stripe (payments)",
  flutterwave: "Flutterwave (payments)",
  resend: "Resend (email)",
  emergent_llm: "Emergent LLM key (assistant)",
};

export default function SystemHealthTile() {
  const [status, setStatus] = useState({});
  const [busy, setBusy] = useState(false);
  const [checked, setChecked] = useState(null);

  const load = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/admin/health");
      setStatus(data);
      setChecked(data.checked_at);
    } catch { /* silent */ }
    finally { setBusy(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="mv-card p-5" data-testid="system-health-tile">
      <div className="flex items-center justify-between gap-3 mb-4">
        <div>
          <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ System Health</span></div>
          <div className="font-display text-lg mv-green-text mt-1">Live integrations status</div>
        </div>
        <button onClick={load} disabled={busy} className="btn-ghost !py-1.5 !px-3" data-testid="health-refresh">
          <RefreshCw size={13} className={busy ? "animate-spin" : ""}/> Refresh
        </button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        {Object.entries(LABELS).map(([k, label]) => {
          const on = status[k];
          return (
            <div key={k} className="flex items-center gap-2 p-2.5 rounded-xl border mv-hairline bg-white" data-testid={`health-${k}`}>
              <Circle size={10} fill={on ? "#0A7A2C" : "#B33A3A"} color={on ? "#0A7A2C" : "#B33A3A"}/>
              <div className="text-[13px] mv-green-text font-medium">{label}</div>
              <div className="ml-auto text-[10.5px] uppercase tracking-[0.14em]" style={{ color: on ? "#0A7A2C" : "#B33A3A" }}>
                {on ? "OK" : "OFF"}
              </div>
            </div>
          );
        })}
      </div>
      {checked && (
        <div className="mt-3 text-[11px]" style={{ color: "var(--mv-muted)" }}>
          Checked at {String(checked).slice(11, 19)} UTC
        </div>
      )}
    </div>
  );
}
